
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60 29.97c0 4.07-.8 7.97-2.4 11.68A29.46 29.46 0 0141.63 57.6a29.46 29.46 0 01-23.32 0A29.56 29.56 0 012.36 41.65 29.39 29.39 0 010 29.97c0-4.07.77-7.95 2.36-11.65A29.5 29.5 0 0118.31 2.4a29.52 29.52 0 0123.32 0 29.4 29.4 0 0115.98 15.92A29.23 29.23 0 0160 29.97zm-3.64 0c0-4.76-1.18-9.16-3.54-13.2a26.42 26.42 0 00-9.65-9.61 25.83 25.83 0 00-13.22-3.55c-4.76 0-9.15 1.18-13.19 3.55a26.36 26.36 0 00-9.6 9.61 25.8 25.8 0 00-3.52 13.2 26.68 26.68 0 007.68 18.7 26.84 26.84 0 0018.63 7.72c4.76 0 9.18-1.19 13.22-3.55a26.32 26.32 0 0013.19-22.87zm-15.32 8.99c.7.71.75 1.8 0 2.56-.66.66-1.87.66-2.53 0l-9.8-9.81c-.4-.4-.56-.89-.5-1.48 0-.1-.06-.23-.06-.26V12.7c0-1.02.85-1.84 1.8-1.84 1.02 0 1.9.82 1.9 1.84v17z"}})])
          )
        }
      }
    